import {Typography, useTheme} from "@mui/material";
import {useState} from "react";
import {Controller, useFormContext} from "react-hook-form";
import {CustomAutocomplete} from "ui";
import {AutoCompleteData} from "ui/CustomAutoComplete/CustomAutoComplete";
import useChangeDAteAndAutocomplete from "views/ProcessDetails/hooks/useChangeDAteAndAutocomplete";
import useValidateVoyages from "views/ProcessDetails/hooks/useValidateVoyages";
import {getLocationType} from "views/ProcessDetails/refactor/components/ProcessBoarding/components/VoyagesV2/utils/getLocationType";
import useHandleBoardingOptions from "views/ProcessDetails/refactor/components/ProcessBoarding/useHandleBoardingOptions";
import {Process} from "views/ProcessDetails/refactor/types/process.types";
import {Voyage} from "views/ProcessDetails/refactor/types/voyages.types";
import {getTooltipText} from "views/ProcessDetails/utils/getTooltipText";

type Props = {
  index: number;
  disabled: boolean;
  voyage: Voyage;
  allVoyages: Voyage[];
  isAiProcess: boolean;
};

const VoyageOriginField = (props: Props) => {
  const {index, disabled, voyage, isAiProcess} = props;
  const {control} = useFormContext<Process>();

  const {
    getOptions: getBoardingOptions,
    onBottomScroll: onBottomScrollBoarding,
    isLoadingOptions: isLoadingBoardingOptions,
  } = useHandleBoardingOptions();
  const {handleChangeAutocomplete, mountOptions} =
    useChangeDAteAndAutocomplete();

  const [boardingOptions, setBoardingOptions] = useState(
    [] as AutoCompleteData[],
  );
  const [searchFields, setSearchFields] = useState({
    vessels: "",
    origin: "",
    destination: "",
  });

  const {shouldDisableOrigin} = useValidateVoyages();
  const theme = useTheme();

  return (
    <>
      <Controller
        name={
          `boarding.voyages[${index}].origin` as `boarding.voyages.0.origin`
        }
        control={control}
        render={({field: {value}}) => (
          <CustomAutocomplete
            optionSecondaryContent
            fullWidth
            textFieldProps={{
              label: "Origem",
            }}
            name={`boarding.voyages[${index}].origin`}
            placeholder="Origem"
            tooltipText={getTooltipText(value?.name)}
            loading={isLoadingBoardingOptions}
            options={mountOptions(value, boardingOptions)}
            value={value?.name ?? ""}
            onOpen={() =>
              getBoardingOptions(
                setBoardingOptions,
                "",
                1,
                50,
                getLocationType(isAiProcess, voyage?.typeVoyage?.id),
              )
            }
            onInputChange={(e, value) => {
              if (e !== null) {
                setSearchFields((prev) => ({
                  ...prev,
                  origin: value,
                }));
                getBoardingOptions(
                  setBoardingOptions,
                  value,
                  1,
                  50,
                  getLocationType(isAiProcess, voyage?.typeVoyage?.id),
                );
              }
            }}
            getNextPage={() => {
              onBottomScrollBoarding(
                setBoardingOptions,
                searchFields.origin,
                getLocationType(isAiProcess, voyage?.typeVoyage?.id),
              );
            }}
            onChange={(e, value) => {
              handleChangeAutocomplete(
                e,
                value,
                `boarding.voyages[${index}].origin`,
              );
            }}
            isOptionEqualToValue={(option, value) => value === option?.label}
            disabled={shouldDisableOrigin(voyage as any)?.disabled || disabled}
          />
        )}
      />
      {shouldDisableOrigin(voyage as any)?.message && (
        <Typography variant="subtitle3" color={theme.palette.primary.main}>
          {shouldDisableOrigin(voyage as any)?.message}
        </Typography>
      )}
    </>
  );
};

export default VoyageOriginField;
